import "../stylesheets/application.css";
require.context("../images", true, /\.(png|jpg|jpeg|svg)$/);
var componentRequireContext = require.context("../components", true)
var ReactRailsUJS = require("react_ujs")
ReactRailsUJS.useContext(componentRequireContext)// Support component names relative to this directory: